import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';
import { spotFinder } from './endpoints';

export const miscellaneousApi = createApi({
  reducerPath: 'miscellaneousApi',
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['miscellaneous'],
  endpoints: (builder) => ({
    findMiscellaneousChargeById: builder.mutation({
      query({id, token}) {
        return {
          url: `${spotFinder.miscellaneousController.findMiscellaneousChargeById}/${id}`,
          method: 'GET',
          headers: { Authorization: `Bearer ${token}` },
        };
      },
    }),

    findMiscellaneousChargesByBookingId: builder.mutation({
      query({bookingId, token}) {
        return {
          url: `${spotFinder.miscellaneousController.findMiscellaneousChargesByBookingId}/${bookingId}`,
          method: 'GET',
          headers: { Authorization: `Bearer ${token}` },
        };
      },
    }),

    findMiscellaneousChargesByLabourId: builder.mutation({
      query({labourId, token}) {
        return {
          url: `${spotFinder.miscellaneousController.findMiscellaneousChargesByLabourId}/${labourId}`,
          method: 'GET',
          headers: { Authorization: `Bearer ${token}` },
        };
      },
    }),

    getMiscellaneousByLabourAndBooking: builder.mutation({
      query({labourId, bookingId, token}) {
        return {
          url: `${spotFinder.miscellaneousController.getMiscellaneousByLabourAndBooking}/${labourId}/${bookingId}`,
          method: 'POST',
          headers: { Authorization: `Bearer ${token}` },
        };
      },
    }),

    saveMiscellaneousCharge: builder.mutation({
      query(body) {
        return {
          url: spotFinder.miscellaneousController.saveMiscellaneousCharge,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    updateMiscellaneousCharge: builder.mutation({
      query(body) {
        return {
          url: spotFinder.miscellaneousController.updateMiscellaneousCharge,
          method: 'PUT' ,
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    deleteMiscellaneousCharge: builder.mutation({
      query({id, token}) {
        return {
          url: `${spotFinder.miscellaneousController.deleteMiscellaneousCharge}/${id}`,
          method: 'DELETE',
          headers: { Authorization: `Bearer ${token}` },
        };
      },
    }),
  }),
});


export const {
  useFindMiscellaneousChargeByIdMutation,
  useFindMiscellaneousChargesByBookingIdMutation,
  useSaveMiscellaneousChargeMutation,
  useFindMiscellaneousChargesByLabourIdMutation,
  useGetMiscellaneousByLabourAndBookingMutation,
  useUpdateMiscellaneousChargeMutation,
  useDeleteMiscellaneousChargeMutation,
} = miscellaneousApi;
